<template>
  <el-card class="mt15">
    <template slot='header'>
    <div>库位设置</div>
    </template>
    <el-row :gutter="20" class="storageW">
      <el-col :span="6" v-for="(s,index) in storage" :key="'s_' + index">
        库位名称：
        <el-input
          style="width:180px"
          placeholder="名称"
          v-model="storage[index]['name']"
          @input="handleInput"
          >
          <span slot="append" @click="handleDel(index)" class="el-icon-delete deleteStorage" v-if="index > 0"></span>
        </el-input>
      </el-col>
      <el-col :span="6"><el-button @click="handleAdd" type="primary" icon="el-icon-plus"></el-button></el-col>
    </el-row>
  </el-card>
</template>
<script>
  export default {
    props: {
      value:{
        type:Array,
        default: () => []
      }
    },
    watch:{
      value:{
        handler (v) {
          if (Array.isArray(v) && v.length > 0) {
            this.storage = v
          } 
        },
        immediate: true
      }
    },
    data () {
      return {
        timer: null,
        storage:[
          {
            is_default:true,
            name:'默认'
          }
        ]
      }
    },
    methods: {
      updateValue () {
        // let val = this.storage.filter(v => String(v.name).trim() !== "")
        // console.log('val:',val)
        this.$emit('input', this.storage)
      },
      handleInput () {
        if (this.timer !== null) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          this.updateValue()
        }, 500);
      },
      handleDel (index) {
        this.storage.splice(index,1)
        this.updateValue()
      },
      handleAdd () {
        this.storage.push({
          is_default: false,
          name:''
        })
      }
    },
    mounted () {
      this.updateValue()
    }
  }
</script>
<style>
.storageW .el-col-6 {
  margin-bottom:10px;
}
.deleteStorage{
  cursor:pointer;
  &:hover{
    color:red;
  }
}
</style>